var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseControl',_vm._b({attrs:{"errors":_vm.combinedErrors}},'BaseControl',_vm.$attrs,false),[_c('markdown-editor',{model:{value:(_vm.local),callback:function ($$v) {_vm.local=$$v},expression:"local"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }